import { render, staticRenderFns } from "./house.vue?vue&type=template&id=0ee47e1a"
import script from "./house.vue?vue&type=script&lang=ts"
export * from "./house.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports